export default __webpack_public_path__ + "static/media/ETH.18ad5f14.svg";